<template>
</template>

<script>
export default {
	name:'ui-option'
}
</script>

<style>
</style>